import { Mail, Phone, MapPin, Linkedin, Instagram } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-brand-azul text-white py-16">
      <div className="container px-4 mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-10">
          <div>
            <Link to="/" className="inline-block">
              <img
                src="/brand/logo-principal.svg"
                alt="dgenny"
                className="h-9 w-auto mb-5"
              />
            </Link>
            <p className="text-white/70 text-sm leading-relaxed mb-4">
              Negocie. Compre. Escale. A I.A. que conduz compras B2B no ritmo da sua operação.
            </p>
            <p className="text-brand-rosa text-xs uppercase tracking-wider font-semibold">
              O crescimento deixa de ser acaso.
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold mb-4 text-brand-rosa uppercase tracking-wider">Navegue</h3>
            <ul className="space-y-2.5">
              <li>
                <button
                  onClick={() => scrollToSection('super-agente')}
                  className="text-white/70 hover:text-white transition-colors text-sm"
                >
                  Super Agente
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('cases')}
                  className="text-white/70 hover:text-white transition-colors text-sm"
                >
                  Casos
                </button>
              </li>
              <li>
                <Link
                  to="/calculadora-roi"
                  className="text-white/70 hover:text-white transition-colors text-sm"
                >
                  Calculadora de ROI
                </Link>
              </li>
              <li>
                <Link
                  to="/politica-de-privacidade"
                  className="text-white/70 hover:text-white transition-colors text-sm"
                >
                  Política de privacidade
                </Link>
              </li>
              <li>
                <Link
                  to="/termos-de-uso"
                  className="text-white/70 hover:text-white transition-colors text-sm"
                >
                  Termos de uso
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold mb-4 text-brand-rosa uppercase tracking-wider">Fale com a gente</h3>
            <ul className="space-y-3">
              <li className="flex items-center gap-3">
                <Mail size={16} className="text-brand-rosa shrink-0" />
                <a href="mailto:compre.ai@dgenny.com.br" className="text-white/70 hover:text-white transition-colors text-sm">
                  compre.ai@dgenny.com.br
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={16} className="text-brand-rosa shrink-0" />
                <a href="tel:+5548988509968" className="text-white/70 hover:text-white transition-colors text-sm">
                  (48) 98850-9968
                </a>
              </li>
              <li className="flex items-center gap-3">
                <MapPin size={16} className="text-brand-rosa shrink-0" />
                <span className="text-white/70 text-sm">Florianópolis, Brasil</span>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold mb-4 text-brand-rosa uppercase tracking-wider">Siga a dgenny</h3>
            <div className="flex gap-4">
              <a
                href="https://www.linkedin.com/company/dgenny/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-white/70 hover:text-white transition-colors text-sm"
              >
                <Linkedin className="w-5 h-5" />
                <span className="hidden sm:inline">LinkedIn</span>
              </a>
              <a
                href="http://instagram.com/dgenny.ai"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-white/70 hover:text-white transition-colors text-sm"
              >
                <Instagram className="w-5 h-5" />
                <span className="hidden sm:inline">Instagram</span>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 text-center">
          <p className="text-white/50 text-xs">
            © {currentYear} dgenny. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
}
